module.exports = "label {\r\n  font-weight: bold;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/userConnect/userConnect.component.css
// module id = ./src/app/components/userConnect/userConnect.component.css
// module chunks = main